import { t, lang } from '@/plugins/i18n'
import dayjs from 'dayjs'
import { getJapanTime } from '@/util/common'
import returnDefectiveText from './components/defective'

interface row {
  orderProcessResult: number,
  orderProcessTime: string,
  defectiveCode: string,
  noAdditionalFlag: number,
  additionNameJp: string,
  additionName: string
}
export const orderProcessResult: any = { 0: t('未处理'), 1: t('处理中(转正品)'), 2: t('已作废'), 3: t('已转正品') }
const timeFormat = (time: any) => {
  return getJapanTime(time)
}
export const pageColumns: any = [
  {
    label: t('次品数'),
    prop: 'defectiveAmount',
    align: 'center',
    className: 'product-gary',
    minWidth: 50
  },
  {
    label: t('次品原因'),
    prop: 'defectiveReason',
    align: 'center',
    className: 'product-gary',
    formatter: (row: row) => {
      return !row.defectiveCode ? '-' : returnDefectiveText(row.defectiveCode)
    }
  },
  {
    label: t('次品图片'),
    prop: 'defectiveImg',
    align: 'center',
    className: 'product-gary',
    slotName: 'defectiveImg'
  },
  {
    label: t('所属订单编号'),
    prop: 'platformOrderNo',
    className: 'product-gary',
    align: 'center'
  },
  {
    label: t('附加项'),
    prop: 'addition',
    align: 'center',
    className: 'product-gary',
    slotName: 'addition',
    formatter: (row: row) => {
      return row.orderProcessResult === 2 ? '-' : row.noAdditionalFlag === 0 ? `${t('不需要检品')}` : row.noAdditionalFlag ===
        1 ? (lang === 'ja'
          ? row.additionNameJp : row.additionName) : ''
    }
  },
  {
    label: t('处理结果'),
    prop: 'orderProcessResult',
    align: 'center',
    minWidth: 180,
    className: 'product-gary',
    slotName: 'orderProcessResult',
    formatter: (row: row) => {
      return orderProcessResult[row.orderProcessResult]
    }
  },
  {
    label: t('处理时间'),
    className: 'product-gary',
    prop: 'orderProcessTime',
    align: 'center',
    formatter: (row: row) => {
      return timeFormat(row.orderProcessTime)
    }
  }
]

export const pageTableConfig = {
  showSelection: true,
  // showExpand: true,
  showHandler: true,
  setHeight: true,
  selectable: (row: any) => row.orderProcessResult === 0,
  handlerConfig: {
    width: 260,
    handlerHead: true,
    fixed: false
  }
}

export const apiConfig = { listPath: 'data.regularizationPage.records', totalPath: 'data.regularizationPage.total' }
